//@ts-nocheck
import React from "react";

import MDButton from "../../../components/MDButton";
import { Delete, Edit, Refresh, WidthFull } from "@mui/icons-material";
import MDBox from "../../../components/MDBox";
import { Chip, Typography } from "@mui/material";
import MDTypography from "components/MDTypography";

export interface FileColumnsWithSignature {
  Header: string;
  accessor: string;
  width: number;
  minWidth?: number;
  maxWidth?: number;
  Cell?: React.FC<{ row: { original: any } }>;
}

const filesColumnWithSignature: FileColumnsWithSignature[] = (
  handleDownloadFile: (media: any) => void,
  handleDeleteMediaAttachment: (media: any) => void,
  handleEditSelected: (selected: any) => void,
  handleSignatureSelected: (
    chipLabel: any,
    applicationId: any,
    mediaId: any,
    isRecordCreated: any
  ) => void
) => [
  {
    Header: "NAME",
    accessor: "name",
    allowSelection: false,
    minWidth: 270,
    Cell: ({ row }) => {
      const media = row.original;
      return (
        <MDTypography
          component="a"
          href="#"
          fontSize="15px"
          onClick={(e) => {
            e.preventDefault();
            if (media) {
              handleDownloadFile(media);
            }
          }}
          sx={{
            textDecoration: "none",
            color: "inherit",
            "&:hover": {
              textDecoration: "underline",
              color: (theme) => theme.palette.info.main,
            },
            cursor: "pointer",
          }}
        >
          {media.name}
        </MDTypography>
      );
    },
  },
  {
    Header: "CATEGORY",
    accessor: "category",
    minWidth: 70,
    width: 70,
  },
  {
    Header: "DESCRIPTION",
    accessor: "description",
    minWidth: 300,
  },
  {
    Header: "Signature",
    accessor: "signature",
    minWidth: 65,
    width: 65,
    Cell: ({ row }: any) => {
      const createSignatureStatusButton = (row) => {
        const originalObject = row && row.original;
        const filePrefix = originalObject && originalObject.name && originalObject.name.split(".");
        const status =
          originalObject && originalObject.signatureStatus ? originalObject.signatureStatus : "";
        const mediaId = originalObject && originalObject.id ? originalObject.id : "";
        const applicationId =
          originalObject && originalObject.dealApplicationId
            ? originalObject.dealApplicationId
            : "";
        const isSignatureFile =
          originalObject &&
          originalObject.category &&
          originalObject.category === "Contract" &&
          originalObject.mediaThrough === "dealApplicationAttachments";
        const showStatusChip =
          filePrefix && filePrefix.length > 0 && filePrefix[filePrefix.length - 1] === "pdf";

        let disabled = false;
        let isRecordCreated = false;
        let chipLabel = "";
        let failureMessage = "";
        let chipStyles = {};

        switch (status) {
          case "pending":
            chipStyles.backgroundColor = "#23CCEF";
            chipLabel = "Resend Request";
            break;
          case "completed":
            chipStyles.backgroundColor = "#7B7A7A";
            chipLabel = "Signed";
            disabled = true;
            break;
          case "failed":
            chipStyles.backgroundColor = "#FF6B6B";
            failureMessage = row && row.original && row.original.failureMessage;
            chipLabel = "Failed to Send";
            break;
          case "created":
            isRecordCreated = true;
            chipStyles.backgroundColor = "#66BB6A";
            chipLabel = "Request Signature";
            break;
          default:
            chipStyles.backgroundColor = "#66BB6A";
            chipLabel = "Request Signature";
            break;
        }

        return (
          <div style={{ flex: 1 }}>
            {showStatusChip && isSignatureFile && (
              <Chip
                label={chipLabel}
                style={{
                  backgroundColor: chipStyles.backgroundColor,
                  color: "white",
                  borderRadius: "20px",
                  fontSize: 11,
                  padding: "2px 2px",
                  cursor: "default",
                }}
                variant="filled"
                disabled={disabled}
                onClick={() => {
                  if (chipLabel !== "Failed to Send") {
                    handleSignatureSelected(chipLabel, applicationId, mediaId, isRecordCreated);
                  } else {
                    console.log("Signature clicked");
                  }
                }}
              />
            )}
          </div>
        );
      };

      return createSignatureStatusButton(row);
    },
  },
  {
    Header: "UPLOADED BY",
    accessor: "createdBy",
    minWidth: 70,
    width: 70,
  },
  {
    Header: "Date",
    accessor: "updatedAt",
    minWidth: 60,
    width: 60,
    Cell: ({ row }) => {
      const dateString = row?.original?.updatedAt;

      if (!dateString) {
        return <span></span>;
      }

      const dateParts = dateString.split(" ")[0];

      if (!dateParts || dateParts.split("-").length !== 3) {
        return <span></span>;
      }

      const [year, month, day] = dateParts.split("-");

      const formattedDate = `${month}-${day}-${year.slice(-2)}`;

      return <span>{formattedDate}</span>;
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    minWidth: 60,
    Cell: ({ row }: any) => {
      return (
        <MDBox display={"flex"} justifyContent={"flex-start"}>
          <MDButton
            variant="text"
            color="error"
            onClick={() => {
              const media = row.original;
              handleDeleteMediaAttachment(media);
            }}
            startIcon={<Delete />}
          >
            Delete
          </MDButton>
          <MDButton
            variant="text"
            color="secondary"
            startIcon={<Edit />}
            onClick={() => {
              const media = row.original;
              handleEditSelected(media);
            }}
          >
            {" "}
            Edit
          </MDButton>
        </MDBox>
      );
    },
  },
];

export default filesColumnWithSignature;
